// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopTariffControllerGetAllData } from './EshopTariffControllerGetAllData.gen';
import type { EshopTariffControllerGetAllErrors } from './EshopTariffControllerGetAllErrors.gen';
import type { EshopTariffControllerGetAllResponses } from './EshopTariffControllerGetAllResponses.gen';
import type { EshopTariffControllerGetTariffData } from './EshopTariffControllerGetTariffData.gen';
import type { EshopTariffControllerGetTariffErrors } from './EshopTariffControllerGetTariffErrors.gen';
import type { EshopTariffControllerGetTariffResponses } from './EshopTariffControllerGetTariffResponses.gen';
import type { EshopTariffControllerGetValidityData } from './EshopTariffControllerGetValidityData.gen';
import type { EshopTariffControllerGetValidityErrors } from './EshopTariffControllerGetValidityErrors.gen';
import type { EshopTariffControllerGetValidityResponses } from './EshopTariffControllerGetValidityResponses.gen';
import type { EshopTariffControllerShouldOfferAllNetworkTariffData } from './EshopTariffControllerShouldOfferAllNetworkTariffData.gen';
import type { EshopTariffControllerShouldOfferAllNetworkTariffErrors } from './EshopTariffControllerShouldOfferAllNetworkTariffErrors.gen';
import type { EshopTariffControllerShouldOfferAllNetworkTariffResponses } from './EshopTariffControllerShouldOfferAllNetworkTariffResponses.gen';
import type { Options } from './Options.gen';

export class EshopTariffController {
    /**
     * Get tariffs
     */
    public static getAll<ThrowOnError extends boolean = false>(options: Options<EshopTariffControllerGetAllData, ThrowOnError>) {
        return (options.client ?? client).get<EshopTariffControllerGetAllResponses, EshopTariffControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tariffs',
            ...options
        });
    }
    
    /**
     * Get tariff by customer profile and tariff profiles
     */
    public static getTariff<ThrowOnError extends boolean = false>(options: Options<EshopTariffControllerGetTariffData, ThrowOnError>) {
        return (options.client ?? client).get<EshopTariffControllerGetTariffResponses, EshopTariffControllerGetTariffErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tariffs/by-tariff-profiles',
            ...options
        });
    }
    
    /**
     * Should offer All Network tariff
     */
    public static shouldOfferAllNetworkTariff<ThrowOnError extends boolean = false>(options: Options<EshopTariffControllerShouldOfferAllNetworkTariffData, ThrowOnError>) {
        return (options.client ?? client).get<EshopTariffControllerShouldOfferAllNetworkTariffResponses, EshopTariffControllerShouldOfferAllNetworkTariffErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tariffs/should-offer-all-network-tariff',
            ...options
        });
    }
    
    /**
     * Get ticket validity by tariff and valid from
     */
    public static getValidity<ThrowOnError extends boolean = false>(options: Options<EshopTariffControllerGetValidityData, ThrowOnError>) {
        return (options.client ?? client).get<EshopTariffControllerGetValidityResponses, EshopTariffControllerGetValidityErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tariffs/{id}/ticket-validity',
            ...options
        });
    }
}
